export default [
  { routeName: "clientsEdit", tabTitle: "Datos de cliente" },
  { routeName: "clients-portfolios", tabTitle: "Carteras" },
  { routeName: "clients-subscription", tabTitle: "Suscripción de usuario" },
];
